export default __webpack_public_path__ + "static/media/background.d2e01bf2.png";